module.exports = __webpack_public_path__ + "img/folder.e6f904bc.png";